import { store } from '@store/store'
import { DjangoFilter } from '@store/slices/generic.slice'
import { TemplateType } from '@shared/enums'
import { fetchAllTemplates, TemplateModel } from '@store/slices/template.slice'

export const fetchSsmlTemplates = async (): Promise<TemplateModel[]> => {
  const dispatch = store.dispatch
  const filter = new DjangoFilter<TemplateModel>()
  filter.addFilter({ type: TemplateType.SSML_TEMPLATE })
  return dispatch(fetchAllTemplates(filter)).then()
}
